import loadable from '@loadable/component'

export const IframeEmbed = loadable(() => import('./IframeEmbed'))
export { default as IframeEmbedFullWidth } from './IframeEmbedFullWidth'
export type { IframeEmbedProps } from './IframeEmbed'
